// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "@msnews/social-utils";

export interface ReportMenuTelemetryObjects {
    reportItems: TelemetryObjectBase[];
    reportMenu: TelemetryObjectBase;
}

export const reportMenuTelemetryContracts = {
    /**
     * Comments-Scenario-10b
     * headline: dynamically set for each report reason
     * */
    reportItem: {
        name: "Report",
        behavior: TelemetryBehaviorType.Report,
        content: { type: TelemetryContentType.Comment }
    },
    /** Comments-Scenario-10ai */
    reportMenu: {
        name: "ReportedReason",
        content: { type: TelemetryContentType.Comment }
    }
};

export const reportMenuTelemetryActionDispatchers = {
    reportItemClick: genericTelemetryClickDispatcher
};